/*
 *  Header with gradient
 *
 *  ToDo: rewrite!
 */

const showMenu = () => {
	const dropMenu = document.querySelector(".dropmenu ul");

	if (!dropMenu) return false;

	dropMenu.style.display =
		dropMenu.style.display === "block" ? "none" : "block";

	if (dropMenu.style.display === "block") {
		document.querySelector(".dropmenu").className += " active ";
	} else {
		document.querySelector(".dropmenu").className = "menu-item dropmenu";
	}

	return true;
};

const toggleMenu = () => {
	const dropMenuLink = document.querySelector(".dropmenu .menu-link");

	if (dropMenuLink) {
		if (
			"onkeydown" in document.documentElement ||
			"ontouchstart" in document.documentElement
		) {
			dropMenuLink.addEventListener("touchstart", showMenu, false);
		}
	}
};

document.addEventListener("DOMContentLoaded", () => {
	// Dropdown menu for touch devices
	toggleMenu();

	let headerPos = 0;

	if (document.querySelector(".header-block")) {
		headerPos =
			window.innerWidth > 980
				? document.querySelector(".top-block").getBoundingClientRect()
						.height
				: 0;
	}

	/* fixed menu */
	window.addEventListener("scroll", () => {
		const doc = document.documentElement;
		const top =
			(window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
		const topContainer = document.querySelector(".header-gradient")
			? document.querySelector(".header-gradient")
			: document.querySelector(".header-section");
		const bodyClassName = document.getElementsByTagName("body")[0]
			.className;
		if (
			bodyClassName.indexOf("order-page") === -1 &&
			bodyClassName.indexOf("rcform-page") === -1
		) {
			if (top > 0 && top > headerPos) {
				document.querySelector(".header-block").classList.add("fixed");
				topContainer.classList.add("fixed-header");
			} else {
				document
					.querySelector(".header-block")
					.classList.remove("fixed");
				topContainer.classList.remove("fixed-header");
			}
		}
	});

	if (document.querySelector("[data-action]")) {
		document
			.querySelector("[data-action]")
			.addEventListener("click", function() {
				/* eslint-disable-line */
				this.classList.toggle("active");
				document
					.querySelector(`[data-dest="${this.dataset.action}"]`)
					.classList.toggle("active");
				document.querySelector(".overlay").classList.toggle("show");
				document
					.getElementsByTagName("html")[0]
					.classList.toggle("overflow");
				document
					.getElementsByTagName("body")[0]
					.classList.toggle("overflow");
			});
	}
});
